export default __webpack_public_path__ + "fbfe84e9759edb6974c6b3ff9055b0ca.png";